const { createContext, useCallback, useContext } = require("react");

const AuthContext = createContext(null)

const useAuthContext = () => {
  return useContext(AuthContext)
}

export { AuthContext, useAuthContext }